import { getTranslatedText } from '@nile/components/src';
import { DisplayText, Heading, TextStyle } from '@superops/ui-design-system';
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import shortid from 'shortid';
import styled from 'styled-components';
import { injectIntl, FormattedMessage } from 'react-intl';

class Placeholder extends Component {
  constructor(props) {
    super(props);
    this.dragEl = React.createRef();
  }

  dragstart() {}

  drag() {}

  dragend() {}

  componentDidMount() {
    this.dragEl.current.addEventListener('dragstart', this.dragstart);
    this.dragEl.current.addEventListener('drag', this.drag);
    this.dragEl.current.addEventListener('dragend', this.dragend);
  }

  render() {
    const { name, className } = this.props;
    return (
      <div className={className} ref={this.dragEl} draggable={false}>
        <TextStyle>{`#${name}`}</TextStyle>
      </div>
    );
  }
}

function PlaceholderContainer(props) {
  const { data, fields, type, intl, isNewMeta } = props;

  let placeholderByGroups = [];
  if (data?.variables) {
    // TODO: perform for placeholders
    placeholderByGroups = [
      ...placeholderByGroups,
      ...data.variables?.map((variable) => ({
        name: getTranslatedText(intl, variable.name),
        items: variable.fields,
        customItems: variable.customFields || []
      }))
    ];
  }

  return (
    <div className="full-height full-width" type={type}>
      <div className="mb-20">
        <Heading element="h2">
          <FormattedMessage id="admin.templates.placeholders.title" />
        </Heading>
      </div>
      {placeholderByGroups?.map((placeholder) => {
        return (
          <div className="pb20">
            {/* <HeaderTag title={placeholder.name} /> */}
            <div className="mb-10 uppercase">
              <DisplayText weight="Medium">
                <TextStyle variation="subdued">{placeholder?.name}</TextStyle>
              </DisplayText>
            </div>
            {placeholder.items?.map((item, idx, arr) => {
              return (
                <Placeholder
                  key={shortid.generate()}
                  name={
                    isNewMeta
                      ? getTranslatedText(intl, item)
                      : fields?.find((field) => field.placeholderValue === item)
                          ?.label || item
                  }
                  className="mb10 ta-l"
                />
              );
            })}
            {placeholder.customItems?.map((item, idx) => {
              return (
                <Placeholder
                  key={shortid.generate()}
                  name={getTranslatedText(intl, item.label)}
                  className="mb10 ta-l"
                />
              );
            })}
          </div>
        );
      })}
    </div>
  );
}

export default injectIntl(withRouter(PlaceholderContainer));
